import { useIntl } from 'react-intl'

import Stack from 'app/components/base/Stack'

import AdditionalInfoItem from '../../components/AdditionalInfoItem'

import msg, { values } from './AdditionalInfo.messages'

interface AdditionalInfoProps {
  condition: string
  itemType: string
  warranty: string
}

const AdditionalInfo: RFC<AdditionalInfoProps> = (props) => {
  const { formatMessage } = useIntl()
  const { condition, warranty, itemType } = props

  const displayWarranty = warranty || '-'

  return (
    <Stack spacing={1} sx={{ pb: 3 }}>
      <AdditionalInfoItem
        title={formatMessage(msg.condition)}
        value={values.condition[condition]}
      />
      <AdditionalInfoItem
        title={formatMessage(msg.warranty)}
        value={displayWarranty}
      />
      <AdditionalInfoItem
        title={formatMessage(msg.type)}
        value={values.type[itemType]}
      />
    </Stack>
  )
}

export default AdditionalInfo
